// Generated by Melange

import * as JsxRuntime from "react/jsx-runtime";

function LegalPrivacyPage(Props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h3", {
        children: "Политика конфиденциальности",
        className: "h4 lg:h3 text-black-landing"
      }),
      JsxRuntime.jsx("h4", {
        children: "и обработки персональных данных мобильного приложения ТОО «Бухта»",
        className: "h5 lg:h4 text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "Политика конфиденциальности и обработки персональных данных мобильного приложения ТОО «Бухта» (далее – Политика) определяет порядок, условия обработки персональных данных пользователей Мобильного приложения, и устанавливает требования по обеспечению Бухта безопасности персональных данных Пользователей.",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "\nПолитика разработана и реализуется в соответствии со следующими нормативными правовыми актами в области обработки и обеспечения безопасности персональных данных:\n",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "\n1) Конституция Республики Казахстан;\n",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "\n2) Закон Республики Казахстан «О персональных данных и их защите»;",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "\nВсе термины и определения, используемые в Политике, понимаются и толкуются в соответствии с условиями, размещенными на сайте Бухта www.buhta.com.\n",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "\nВсе термины и определения, применяемые в Политике, имеют следующее значение:\n",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "\n1) Бухта – ТОО «Бухта», БИН: 140840021970. Адрес: г. Алматы, ул. Тимирязева, 28в, 6 этаж, каб. 612;\n",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "\n2) Мобильное приложение – программное обеспечение, предназначенное для получения электронных услуг посредством мобильного телефона или иного устройства, поддерживающего Мобильное приложение и доступ в интернет;\n",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "\n3) Пользователь – физическое лицо и юридическое лицо, использующее Мобильное приложение;\n",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "\n4) Персональные данные – сведения, относящиеся к определенному или определяемому на их основании субъекту персональных данных, зафиксированные на электронном, бумажном и (или) ином материальном носителе.\n",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "\nПолитика распространяется на всех посетителей, и применяется в отношении предоставленных Пользователями Персональных данных во время скачивания, регистрации и пользования Мобильным приложением.\n",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "\nПользователь, осуществляя все действия, направленные на пользование Мобильным приложением (загрузка, установка, регистрация, использование), принимает в полном объеме все условия Политики и выражает свое добровольное согласие на обработку предоставляемых данных способом и в целях, описанных в Политике. Если Пользователь не согласен с Политикой, он обязан отказаться от загрузки Мобильного приложения. Мобильное приложение является программным обеспечением, предоставляющее доступ Пользователям к сервисам удаленного обслуживания, предназначенное для осуществления Клиентом операций в Личном кабинете посредством мобильного телефона или иного устройства, поддерживающего установку Мобильного приложения, с доступом в интернет.",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "\nБухта вправе вносить изменения или дополнения в Политику в одностороннем порядке, с публикацией изменений или дополнений, или в новой редакции публикации на сайте Бухта www.buhta.com.\n",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("h5", {
        children: "\n1. Сбор и/или обработка Персональных данных Пользователя\n",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "\nПерсональные данные Пользователей собираются Бухта для обеспечения безопасности предоставления электронных услуг посредством Мобильного приложения в следующих целях:\n",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "\n1. Заключения договоров с Бухта;\n",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "\n2. Идентификации Пользователя в рамках договоров;\n",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "\n3. Предоставления Пользователю персонализированных услуг через доступ к сервисам Мобильного приложения;\n",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "\n4. Связь с Пользователем, в том числе направление уведомлений, предложений и информации, касающихся использования продуктов Бухта, оказания услуг, а также обработки запросов от Пользователя;\n",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "\n5. Анализ данных, аудит, разработку новых продуктов, улучшение работы Мобильного приложения, расширение услуг Бухта;\n",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "\n6. Сбор и использование рекламных идентификаторов.\n",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "\n7. Персональные данные Пользователя важны для Бухта, и Бухта предпринял меры для обеспечения Персональных данных от Пользователя только в том количестве, которое необходимо для предоставления Бухта услуг, и для защиты учётной записи Пользователя.\n",
        className: "paragraph text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "\nПри использовании Мобильного приложения Бухта может собирать и обрабатывает следующие Персональные данные, включая, но не ограничивая: ИИН Пользователя, ФИО Пользователя, номер мобильного телефона, дата и/или год рождения, адрес электронной почты, размер заработной платы, размер вознаграждения труда, должность, дата приема на работу, дата увольнения, условия трудового договора, IP адрес, сведения о мобильном устройстве с которого осуществляется доступ, дата и время визитов с Мобильного приложения, версия операционной системы, уникальные идентификаторы устройства, геолокации местоположения, данные GPS, банковские реквизиты, информация о совершенных операциях включая данные о времени и сумме совершенных операций и иное.\n",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "\nПосле предоставления Пользователем согласия, Мобильное приложение получает доступ к геолокации (определению местоположения), для Пользователей системы Android также доступ к SMS сообщениям для автоматического ввода кода подтверждения из SMS сообщения, высланного Бухта.\n",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("h5", {
        children: "\n2. Меры безопасности, используемые для сохранения конфиденциальности информации\n",
        className: "h6 lg:h5 text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "\nБухта обладает современными технологиями и внутренними процедурами и осуществляет все действия, направленные для защиты Ваших Персональных данных от постороннего в мешательства , несанкционированных попыток доступа к информации, изменения, выявление наличия искажений и/или изменений в содержании электронных документов, раскрытия или уничтожения.\n",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "\nМобильное приложение обеспечивает защиту передаваемых данных между клиентом и Бухта в сети интернет по защищенному протоколу HTTPS, используя криптографический протокол TLS v1.3. Пароли Пользователей в системе Бухта не отображаются, хранятся и передаются исключительно в зашифрованном виде. Однако безопасность также зависит от соблюдения Пользователем рекомендаций, с которыми можно ознакомиться на сайте Бухта www.buhta.com.\n",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "\nПользователь обязан не передавать в пользование телефон (в т.ч. SIM карта) третьим лицам (на котором установлен и с которого зарегистрирован или обеспечивается вход в приложении Пользователь), не разглашать, не предоставлять и скрывать при наборе от третьих лиц данные своей учетной записи, такие как логин и пароль. Рекомендуется пользоваться и своевременно обновлять антивирусные программы для обеспечения максимальной защиты. Пользователь обязуется незамедлительно сообщать Бухта о любом случае подозрения несанкционированного использования его учетной записи.\n",
        className: "paragraph text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: "\nВсе права на Мобильное приложение, в том числе реализуемые и разрабатываемые подвязанные сервисы принадлежат ТОО «Бухта».\n",
        className: "paragraph text-black-landing mt-4"
      })
    ],
    className: "flex m-auto flex-col py-10 lg:py-30 px-6 sm:px-48 lg:px-0 lg:w-252"
  });
}

const make = LegalPrivacyPage;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
